import character from './character'

export default character
